import CircularProgress from "@mui/material/CircularProgress";
import { Stack, Typography } from "@mui/material";
import { CustomDialog } from "@web-applications/allinga-web-components";
import { useTranslation } from "react-i18next";

export interface ValidationSuccessfulNotificationProps {
  open: boolean;
  onCancel?: VoidFunction;
}

function ValidationSuccessfulNotification({
  open,
  onCancel,
}: ValidationSuccessfulNotificationProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <CustomDialog
      id="validation-success-dialog"
      open={open}
      header={t("ssml.ssmlViewBanner.successfulValidationHeader")}
      showDivider={false}
      showCloseIcon={false}
      handleOnClose={onCancel}
      hideActions={false}
      tertiaryButtonText={t("buttons.cancel")}
      onTertiaryButtonClick={onCancel}
      maxWidth="xs"
      height="auto"
    >
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <CircularProgress
          size="35px"
          thickness={3.6}
          disableShrink
          sx={{ color: "primary.main" }}
        />
        <Typography variant="body1">
          {t("ssml.ssmlViewBanner.successfulValidationText")}
        </Typography>
      </Stack>
    </CustomDialog>
  );
}

export default ValidationSuccessfulNotification;
